import router from '@/router';

import { createPermissionGuard } from './permissionGuard';

import { createPageGuard } from './pageGuard';

createPermissionGuard(router);

createPageGuard(router);
